import { render, staticRenderFns } from "./VersionIndex.vue?vue&type=template&id=7c31c5ca&"
import script from "./VersionIndex.vue?vue&type=script&lang=js&"
export * from "./VersionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports